export const PHOTO_TYPES = ['jpg', 'jpeg', 'bmp', 'gif', 'png'];
